import { useState, useEffect } from 'react';

const useCountryProvince = (provinceCallback) => {

  const [provinces, setProvinces] = useState([]);
  const [countryRef, setCountryRef] = useState(null);

  useEffect(() => {

    if (!countryRef) return;

    if (countryRef.selectedIndex === 1) {
      console.warn("No country selected.");
    }

    const country = countryRef.options[countryRef.selectedIndex];
    const provinces = (country) ? JSON.parse(country.getAttribute('data-provinces')) : [];

    setProvinces(provinces);

    if (typeof provinceCallback === "function") {
      provinceCallback((provinces && provinces.length) ? provinces[0][0] : "");
    }

  }, [countryRef, countryRef?.selectedIndex]);

  return {
    countryRef: (element) => setCountryRef(element),
    countryEl: countryRef,
    provinces,
  };
};

export default useCountryProvince;
